import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/home.vue'
import StuHome from '../views/stuHome.vue'
import Login from '../views/login.vue'
import Register from '../views/register.vue'
import ForgetPassword from '../views/forgetPassword.vue'
import Index from '../views/index.vue'
// 中心简介
var Introduce = resolve => require(['../views/introduce/Introduce.vue'], resolve)
    //通知公告
var Notice = resolve => require(['../views/notice/NoticeList.vue'], resolve)
    //政策法规
var Policy = resolve => require(['../views/policy/PolicyList.vue'], resolve)
    //人才服务
var Recruit = resolve => require(['../views/recruit/RecruitList.vue'], resolve)
    //职业工种
var Occupation = resolve => require(['../views/occupation/OccupationList.vue'], resolve)
var OccupationGrade = resolve => require(['../views/occupation/OccupationGradeList.vue'], resolve)
    //报名机构
var Company = resolve => require(['../views/company/CompanyList.vue'], resolve)
var CompanyMaster = resolve => require(['../views/company/CompanyMasterList.vue'], resolve)
    //学员管理
var Student = resolve => require(['../views/student/StudentList.vue'], resolve)
    //班级管理
var Class = resolve => require(['../views/class/ClassList.vue'], resolve)
var ClassStudent = resolve => require(['../views/class/ClassStudentList.vue'], resolve)


//学员端
//中心简介
var StuIntroduce = resolve => require(['../views/introduce/StuIntroduce.vue'], resolve)
    //通知公告
var StuNotice = resolve => require(['../views/notice/StuNotice.vue'], resolve)
var StuNoticeDetails = resolve => require(['../views/notice/StuNoticeDetails.vue'], resolve)
    //政策法规
var StuPolicy = resolve => require(['../views/policy/StuPolicy.vue'], resolve)
var StuPolicyDetails = resolve => require(['../views/policy/StuPolicyDetails.vue'], resolve)
    //人才服务
var StuRecruit = resolve => require(['../views/recruit/StuRecruit.vue'], resolve)
var StuRecruitDetails = resolve => require(['../views/recruit/StuRecruitDetails.vue'], resolve)
    //职业介绍
var StuOccupation = resolve => require(['../views/occupation/StuOccupation.vue'], resolve)
var StuOccupationDetails = resolve => require(['../views/occupation/StuOccupationDetails.vue'], resolve)

    //在线报名
// var StuOnline = resolve => require(['../views/online/StuOnline.vue'], resolve)
    //合作同创
var StuCompany = resolve => require(['../views/company/StuCompany.vue'], resolve)
    //成绩查询/证书查询
var StuAchievement = resolve => require(['../views/query/StuAchievement.vue'], resolve)
var StuCertificate = resolve => require(['../views/query/StuCertificate.vue'], resolve)
    //个人中心
var StuPersonal = resolve => require(['../views/personal/StuPersonal.vue'], resolve)
var StuClass = resolve => require(['../views/personal/StuClass.vue'], resolve)
var StuClassStudents = resolve => require(['../views/personal/StuClassStudents.vue'], resolve)

Vue.use(Router)
// 解决重复点击路由报错的BUG
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};
export default new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/forgetpassword',
            name: 'ForgetPassword',
            component: ForgetPassword,
        },
        {
            path: '/main',
            name: 'home',
            component: Home,
            redirect: '/introduce', //默认跳转中心简介页
            children: [{
                    path: '/introduce',
                    component: Introduce,
                    name: '中心简介',
                    meta: { mainMenuIndex: 1 }
                },
                {
                    path: '/notice',
                    component: Notice,
                    name: '通知公告',
                    meta: { mainMenuIndex: 2 }
                },
                {
                    path: '/policy',
                    component: Policy,
                    name: '政策法规',
                    meta: { mainMenuIndex: 3 }
                },
                {
                    path: '/recruit',
                    component: Recruit,
                    name: '人才服务',
                    meta: { mainMenuIndex: 4 }
                },
                {
                    path: '/occupation',
                    component: Occupation,
                    name: '职业工种',
                    meta: { mainMenuIndex: 5 }
                },
                {
                    path: '/occupationgrade',
                    component: OccupationGrade,
                    name: '职业等级',
                    meta: { mainMenuIndex: 5 }
                },
                {
                    path: '/company',
                    component: Company,
                    name: '报名机构',
                    meta: { mainMenuIndex: 6 }
                },
                {
                    path: '/companymaster',
                    component: CompanyMaster,
                    name: '报名机构管理员',
                    meta: { mainMenuIndex: 6 }
                },
                {
                    path: '/student',
                    component: Student,
                    name: '学员列表',
                    meta: { mainMenuIndex: 7 }
                },
                {
                    path: '/class',
                    component: Class,
                    name: '班级管理',
                    meta: { mainMenuIndex: 8 }
                },
                {
                    path: '/classstudent',
                    component: ClassStudent,
                    name: '班级学员列表',
                    meta: { mainMenuIndex: 8 }
                },


            ]
        },
        {
            path: '/',
            name: 'stuhome',
            component: StuHome,
            redirect: '/index', //默认跳转首页
            children: [
                {
                    path: '/index',
                    component: Index,
                    name: '首页',
                    meta: { menuIndex: 1 }
                },
                {
                    path: '/stuintroduce',
                    component: StuIntroduce,
                    name: '中心简介',
                    meta: { menuIndex: 2 }
                },
                {
                    path: '/stunotice',
                    component: StuNotice,
                    name: '通知公告',
                    meta: { menuIndex: 3 }
                },
                {
                    path: '/stunoticedetails',
                    component: StuNoticeDetails,
                    name: '通知公告详情',
                    meta: { menuIndex: 3 }
                },
                {
                    path: '/stupolicy',
                    component: StuPolicy,
                    name: '政策法规',
                    meta: { menuIndex: 4 }
                },
                {
                    path: '/stupolicydetails',
                    component: StuPolicyDetails,
                    name: '政策法规详情',
                    meta: { menuIndex: 4 }
                },
                {
                    path: '/sturecruit',
                    component: StuRecruit,
                    name: '人才服务',
                    meta: { menuIndex: 5 }
                },
                {
                    path: '/sturecruitdetails',
                    component: StuRecruitDetails,
                    name: '人才服务详情页',
                    meta: { menuIndex: 5 }
                },
                {
                    path: '/stuoccupation',
                    component: StuOccupation,
                    name: '职业介绍',
                    meta: { menuIndex: 6 }
                },
                {
                    path: '/stuoccupationdetails',
                    component: StuOccupationDetails,
                    name: '职业介绍详情',
                    meta: { menuIndex: 6 }
                },
                {
                    path: '/stucompany',
                    component: StuCompany,
                    name: '合作同创',
                    meta: { menuIndex: 7 }
                },
                {
                    path: '/stuachievement',
                    component: StuAchievement,
                    name: '成绩查询',
                    meta: { menuIndex: 8 }
                },
                {
                    path: '/stucertificate',
                    component: StuCertificate,
                    name: '证书查询',
                    meta: { menuIndex: 9 }
                },
                {
                    path: '/register',
                    name: 'Register',
                    component: Register,
                },
                {
                    path: '/stupersonal',
                    component: StuPersonal,
                    name: '个人中心',
                    meta: { menuIndex: 10 }
                },
                {
                    path: '/stuclass',
                    component: StuClass,
                    name: '我的班级',
                    meta: { menuIndex: 11 }
                },
                {
                    path: '/stuclassstudents',
                    component: StuClassStudents,
                    name: '学员列表',
                    meta: { menuIndex: 11 }
                },

            ]
        },

    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js